import raw from '../scene.json'

export interface Point {
  x: number
  y: number
}

export interface SceneConfig {
  canvas: { w: number; h: number }
  /** Full-frame images in order of worsening health. */
  stages: string[]
  /** Full-frame image shown once the boss is defeated. */
  final: string
  /** Descending hp ratios. ratio > thresholds[i] selects stage i; below all of them, the last stage. */
  stageThresholds: number[]
  /** Normalised point the crop keeps centred when the viewport is narrower than the frame. */
  focus?: Point
  /** Portrait phones: fraction of the frame width to show, and where to centre it. */
  mobile?: { crop: number; focusX: number }
  /** Desktop: never scale the frame above this multiple of its native size. */
  desktop?: { maxScale: number }
  /** Where each goal's sparks and numbers spawn, in goal order. Purely visual. */
  impacts: Point[]
  defaultImpact: Point
}

export const scene = raw as SceneConfig

/** Index into scene.stages for a living boss, from overall progress 0..1. */
export function stageIndex(progress: number): number {
  const n = scene.stages.length
  const remaining = 1 - Math.max(0, Math.min(1, progress))
  const i = scene.stageThresholds.findIndex((t) => remaining > t)
  return i === -1 ? n - 1 : Math.min(i, n - 1)
}

export function impactFor(goalIndex: number): Point {
  return scene.impacts[goalIndex] ?? scene.defaultImpact
}

/** Every image the scene can ever show, for preloading. */
export function allImages(): string[] {
  return [...scene.stages, scene.final]
}
